import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import style from "./ilifepoint.module.scss";
import { formatNumberWithCommasAndDecimal } from "../../helper";
import CurrencyLatestSeperator from "../../helper/currencyLatestSeperator";

function Tiles(props) {
  console.log("🚀 ~ file: tiles.jsx:9 ~ Tiles ~ props:", props);
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const Currency = useSelector((state) => state.curr);

  useEffect(() => {
    let ewalletTiles = props.tilesData.map((items) => {
      var background;
      var img;
      switch (items.text) {
        case "totalAvailable":
          background = style.green;
          img = "income-w.png";
          break;
        case "totalAccumulated":
          background = style.green;
          img = "income-w.png";
          break;
        default:
          background = style.blue;
          img = "income-w.png";
      }

      return {
        amount: items.amount,
        text: items.text,
        background: background,
        img: img,
      };
    });

    setData(ewalletTiles);
  }, [setData, props.tilesData]);

  const removeData = (data) => {
    let array = [];

    for (let i = 0; i < data.length; i++) {
      if (props.repurchase_status === "yes") {
        array.push(data[i]);
      } else if (
        props.repurchase_status === "no" &&
        data[i].text !== "purchaseWallet"
      ) {
        array.push(data[i]);
      }
    }

    return array;
  };

  return (
    <div className={`${style.ewalletTiles}`}>
      {removeData(data)
        .slice(0, 2)
        .map((tiles, index) => {
          return (
            <div
              className={`${
                currentTheme === "theme-dark"
                  ? `${style.dark_mode_Tiles} d-flex`
                  : `${style.Tiles} d-flex`
              }`}
              key={index}
            >
              <div className={`${style.leftIcon} ${tiles.background}`}>
                <img
                  src={
                    require("../../../assets/images/logos/" + tiles.img).default
                  }
                  alt=""
                  style={{
                    width: "41px",
                    height: "41px",
                  }}
                />
              </div>
              <div
                className={`${
                  currentTheme === "theme-dark"
                    ? `${style.dark_mode_tilesData}`
                    : `${style.tilesData}`
                }`}
              >
                <div
                  style={{
                    display: "flex",
                    whiteSpace: "nowrap",
                    flexDirection: "column",
                  }}
                >
                  <h4>{t("Common." + tiles.text)}</h4>
                  <strong>
                    <span
                      className={style.TilesAmount}
                      title={(tiles.amount * Currency.value).toFixed(
                        Currency.precision
                      )}
                      style={{ fontSize: "1.5em", color: "black" }}
                    >
                      {/* {Currency.currentCurr}{" "} */}
                      {/* {CurrencyLatestSeperator(
                        tiles.amount * Currency.value,
                        Currency.precision
                      )} */}
                      {CurrencyLatestSeperator(tiles.amount)}
                    </span>
                  </strong>
                </div>
                {/* <br /> */}
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default Tiles;
